import React from "react";
import { SvgIcon } from "@material-ui/core";

const ScheduleIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M3.5625 9.1875H20.4375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4375 9.1875V6.9375C20.4375 6.63913 20.319 6.35298 20.108 6.142C19.897 5.93103 19.6109 5.8125 19.3125 5.8125H4.6875C4.38913 5.8125 4.10298 5.93103 3.892 6.142C3.68103 6.35298 3.5625 6.63913 3.5625 6.9375V19.3125C3.5625 19.6109 3.68103 19.897 3.892 20.108C4.10298 20.319 4.38913 20.4375 4.6875 20.4375H10.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0625 3.5625V5.8125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9375 3.5625V5.8125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9375 20.4375C18.4228 20.4375 20.4375 18.4228 20.4375 15.9375C20.4375 13.4522 18.4228 11.4375 15.9375 11.4375C13.4522 11.4375 11.4375 13.4522 11.4375 15.9375C11.4375 18.4228 13.4522 20.4375 15.9375 20.4375Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9375 13.6875V15.9375H18.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default ScheduleIcon;
